// English (India)
export default {
  translation: {
    app_name: 'Agora',
    tagline: 'Where Hobbies Build Communities',

    nav_explore: 'Explore',
    nav_find_folks: 'Find Members',
    nav_sign_in: 'Sign in',
    nav_join_free: 'Join free',
    nav_sign_out: 'Sign out',
    nav_my_profile: 'My Profile',
    nav_notifications: 'Notifications',

    auth_register: 'Create account',
    auth_login: 'Sign in',
    auth_name: 'Full name',
    auth_email: 'Email address',
    auth_password: 'Password',
    auth_age: 'Your age',
    auth_city: 'City',
    auth_building: 'Society / Colony / Building name',
    auth_country: 'Country',
    auth_currency: 'Currency',
    auth_locale: 'Language & region',
    auth_already_have_account: 'Already have an account?',
    auth_no_account: "Don't have an account?",

    country_gb: 'United Kingdom',
    country_us: 'United States',
    country_in: 'India',

    city_placeholder_gb: 'e.g. London, Manchester, Birmingham',
    city_placeholder_us: 'e.g. New York, Chicago, Houston',
    city_placeholder_in: 'e.g. Mumbai, Delhi, Bengaluru',
    building_placeholder_gb: 'e.g. Elm Court, St. Mary\'s Estate',
    building_placeholder_us: 'e.g. Riverside Apartments, Oak Tower',
    building_placeholder_in: 'e.g. Shree Krishna Society, DLF Phase 2',
    postcode_label: 'PIN Code',
    postcode_placeholder: 'e.g. 400001',

    profile_edit: 'Edit Profile',
    profile_bio: 'Bio',
    profile_interests: 'Interests',
    profile_location: 'Location',
    profile_theme: 'Display theme',
    profile_currency_settings: 'Currency & Region',
    profile_save: 'Save Changes',
    profile_cancel: 'Cancel',

    group_join: 'Join Group',
    group_leave: 'Leave Group',
    group_members: 'Members',
    group_chat: 'Chat',
    group_events: 'Events',
    group_shop: 'Shop',
    group_campaigns: 'Campaigns',
    group_about: 'About',
    group_full: 'Full',
    group_open: 'Open',

    tip_send: 'Send Tip',
    tip_amount: 'Tip amount',
    tip_message: 'Message (optional)',
    wallet_coins: 'coins',
    wallet_balance: 'Wallet balance',
    tips_earned: 'earned',

    event_register: 'Register',
    event_unregister: 'Unregister',
    event_ticket_price: 'Ticket',
    event_free: 'Free',
    event_capacity: 'Capacity',
    event_registered: 'registered',

    currency_gbp: 'British Pound (£)',
    currency_usd: 'US Dollar ($)',
    currency_inr: 'Indian Rupee (₹)',
    currency_symbol_gbp: '£',
    currency_symbol_usd: '$',
    currency_symbol_inr: '₹',

    locale_en_gb: 'English (UK)',
    locale_en_us: 'English (US)',
    locale_en_in: 'English (India)',
    locale_hi_in: 'हिन्दी (India)',

    age_group_kids: 'Kids (5–12)',
    age_group_teens: 'Teens (13–17)',
    age_group_adults: 'Adults (18–59)',
    age_group_seniors: 'Seniors (60+)',

    theme_playful: '🎨 Playful (colourful)',
    theme_standard: '💼 Standard (dark)',
    theme_accessible: '🔎 Accessible (large text)',

    notif_session_reminder: 'Session reminders',
    notif_new_member: 'New member alerts',
    notif_new_buddy: 'Friend request alerts',

    family_dashboard: 'Family Dashboard',
    family_link_child: 'Link a child account',
    family_child_email: "Child's email address",
    family_gift_coins: 'Gift coins',
    family_link: 'Link',

    find_folks_title: 'Find Members Near You',
    find_folks_desc: 'Discover neighbours in your society who share your hobbies',
    no_results: 'No results found',
    loading: 'Loading…',
    error_generic: 'Something went wrong. Please try again.',
  }
};
